import { useEffect, useState } from "react";
import api from "../api/api";
import { useNavigate } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import { useLocation } from "react-router-dom";
import { FaMapMarkerAlt, FaStar, FaStarHalfAlt, FaRegStar, FaSearch, FaUndo } from "react-icons/fa";
import { Star, Tag, MapPin, Hotel, ArrowRight } from "lucide-react";
import FeaturedLoader from "../components/Loaders/FeaturedLoader";
import { Wifi, Car, Utensils, Dumbbell, Waves, } from "lucide-react";
import { BadgePercent, TicketPercent, Sparkles, Crown, Zap, ShieldCheck, } from "lucide-react";
import aboutImg from "../assets/images/aboutUs.jpg";



export default function HotelList({
    limit,
    showViewAllButton = false,
    showSidebar = true,
    showBanner = false,
    showHeading = false   // ✅ ADD THIS
}) {

    const [hotels, setHotels] = useState([]);
    const [loading, setLoading] = useState(true);

    const location = useLocation();

    const amenityIcons = {
        "Free WiFi": <Wifi size={12} />,
        "Free Parking": <Car size={12} />,
        Restaurant: <Utensils size={12} />,
        "Fitness Centre": <Dumbbell size={12} />,
        "Swimming Pool": <Waves size={12} />,
    };



    // Filters
    const [search, setSearch] = useState("");
    const [minPrice, setMinPrice] = useState(0);
    const [maxPrice, setMaxPrice] = useState(5000);
    const [rating, setRating] = useState(0);

    const [destinations, setDestinations] = useState([]);
    const [selectedDestinations, setSelectedDestinations] = useState([]);

    const navigate = useNavigate();

    // Fetch Destinations
    const fetchDestinations = async () => {
        try {
            const response = await api.get("/destinations");
            setDestinations(response.data);
        } catch (err) {
            console.error("Error fetching destinations:", err);
        }
    };

    useEffect(() => {
        fetchDestinations();
    }, []);

    const handleDestinationChange = (dest) => {
        setSelectedDestinations((prev) =>
            prev.some(d => d.id === dest.id)
                ? prev.filter((d) => d.id !== dest.id)
                : [...prev, dest]
        );
    };

    // Debounce search
    const [debouncedSearch, setDebouncedSearch] = useState(search);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search);
        }, 500);

        return () => clearTimeout(handler);
    }, [search]);

    // Fetch Hotels
    const fetchHotels = async () => {
        setLoading(true);

        try {
            const response = await api.get("/hotels", {
                params: {
                    search: debouncedSearch,
                    destinations: selectedDestinations.map(d => d.id),
                    minPrice,
                    maxPrice,
                    rating,
                },
            });

            setHotels(response.data);
        } catch (err) {
            console.error("Error fetching hotels:", err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchHotels();
    }, [debouncedSearch, minPrice, maxPrice, rating, selectedDestinations]);

    // Stars
    const renderStars = (ratingValue) => {
        return Array.from({ length: 5 }, (_, i) => {
            if (i < Math.floor(ratingValue)) return <FaStar key={i} />;
            if (i === Math.floor(ratingValue) && ratingValue % 1 >= 0.5)
                return <FaStarHalfAlt key={i} />;
            return <FaRegStar key={i} />;
        });
    };

    // Reset Filters
    const isFilterChanged =
        search !== "" ||
        minPrice !== 0 ||
        maxPrice !== 5000 ||
        rating !== 0 ||
        selectedDestinations.length > 0;

    const resetFilters = () => {
        setSearch("");
        setMinPrice(0);
        setMaxPrice(5000);
        setRating(0);
        setSelectedDestinations([]);
    };

    const [loadedImages, setLoadedImages] = useState({});


    return (





        <div className="bg-slate-50 dark:bg-gray-950 min-h-screen">
            <section
                className="
  relative
  h-[380px]
  md:h-[420px]
  flex
  items-center
  bg-cover
  bg-center
  "
                style={{
                    backgroundImage:
                        `linear-gradient(rgba(0,0,0,.65),rgba(0,0,0,.65)), url(${aboutImg})`
                }}
            >


                <div
                    className="
  container
  mx-auto
  px-6
  text-white
  "
                >


                    <p
                        className="
    uppercase
    tracking-[0.3em]
    text-[#D4B76A]
    text-sm
    mb-5
    "
                    >
                        UAE Hotel Collection
                    </p>



                    <h1
                        className="
        text-2xl
        sm:text-3xl
        md:text-5xl
        font-serif
        max-w-3xl
        leading-tight
    "
                    >
                        Discover Premium Hotels
                        Across The UAE
                    </h1>



                    <p
                        className="
    mt-5
    max-w-xl
    text-white/80
    leading-relaxed
    "
                    >
                        Explore luxury resorts, budget-friendly stays,
                        and exclusive hotel deals in Dubai, Abu Dhabi
                        and destinations across the UAE.
                    </p>



                    <div
                        className="
    mt-6
    inline-flex
    items-center
    bg-white/10
    backdrop-blur-md
    border
    border-white/20
    px-5
    py-3
    rounded-full
    text-sm
    "
                    >

                        <span className="text-[#D4B76A] font-bold mr-2">
                            {hotels.length}
                        </span>

                        Hotels Available

                    </div>



                </div>


            </section>
            {/* Heading */}

            {showHeading && (
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">

                    <div>
                        <span className="inline-flex items-center px-4 py-2 rounded-full bg-orange-50 text-[#FF6B35] text-sm font-semibold mb-4">
                            Hotel Collection
                        </span>

                        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 dark:text-white">
                            Find Your Perfect Stay
                        </h2>

                        <p className="text-slate-500 dark:text-gray-400 mt-3">
                            Browse luxury hotels, resorts and budget-friendly stays
                            across Dubai's most popular destinations.
                        </p>
                    </div>

                    <button
                        onClick={() => navigate("/hotels")}
                        className="hidden sm:flex items-center gap-2 px-6 py-3 bg-[#FF6B35] text-white rounded-xl hover:bg-orange-600 transition"
                    >
                        View All Hotels →
                    </button>

                </div>
            )}

            {/* Layout */}
            <div className="container mx-auto px-6 py-24 space-y-10">
                <div className="w-full space-y-6">
                    {/* Sidebar */}
                    {showSidebar && (
                        <div className="w-full">

                            <div
                                className="
            lg:sticky
            lg:top-28
            bg-[#FCFAF5]
            dark:bg-gray-900
            rounded-[28px]
            border border-[#DDD2BA]
            dark:border-gray-800
            shadow-xl
            p-5
            transition-all
        "
                            >


                                {/* Header */}

                                <div className="flex items-center gap-3 mb-5">

                                    <div
                                        className="
                    w-10
                    h-10
                    rounded-full
                    bg-[#EFE7D5]
                    flex
                    items-center
                    justify-center
                "
                                    >

                                        <FaSearch className="text-[#0F766E]" />

                                    </div>


                                    <div>

                                        <h3 className="
                    font-semibold
                    text-[#1F2937]
                    dark:text-white
                ">
                                            Find Your Perfect Stay
                                        </h3>


                                        <p className="
                    text-xs
                    text-gray-500
                    dark:text-gray-400
                ">
                                            Filter luxury hotels & exclusive deals
                                        </p>

                                    </div>


                                </div>




                                <div
                                    className="
                flex
                flex-col
                gap-3

                sm:grid
                sm:grid-cols-2

                lg:flex
                lg:flex-row
                lg:items-center
            "
                                >



                                    {/* Search */}

                                    <div
                                        className="
                    flex
                    items-center
                    gap-3
                    bg-white
                    dark:bg-gray-800
                    border
                    border-[#DDD2BA]
                    dark:border-gray-700
                    px-4
                    py-3
                    rounded-2xl
                    flex-1
                "
                                    >

                                        <FaSearch className="text-[#B89442]" />


                                        <input

                                            type="text"

                                            value={search}

                                            onChange={(e) => setSearch(e.target.value)}

                                            placeholder="Search hotels..."

                                            className="
                        bg-transparent
                        outline-none
                        w-full
                        text-sm
                        text-[#1F2937]
                        dark:text-white
                        placeholder-gray-400
                    "

                                        />


                                    </div>




                                    {/* Min Price */}

                                    <div className="relative">

                                        <span className="
                    absolute
                    -top-2
                    left-3
                    bg-[#FCFAF5]
                    dark:bg-gray-900
                    px-1
                    text-[10px]
                    text-gray-500
                ">
                                            Min AED
                                        </span>


                                        <input

                                            type="number"

                                            value={minPrice}

                                            onChange={(e) => setMinPrice(e.target.value)}

                                            className="
                        w-full
                        lg:w-24
                        px-3
                        py-3
                        rounded-2xl
                        border
                        border-[#DDD2BA]
                        dark:border-gray-700
                        bg-white
                        dark:bg-gray-800
                        text-sm
                        outline-none
                        focus:ring-2
                        focus:ring-[#B89442]
                    "

                                        />

                                    </div>




                                    {/* Max Price */}

                                    <div className="relative">


                                        <span className="
                    absolute
                    -top-2
                    left-3
                    bg-[#FCFAF5]
                    dark:bg-gray-900
                    px-1
                    text-[10px]
                    text-gray-500
                ">
                                            Max AED
                                        </span>


                                        <input

                                            type="number"

                                            value={maxPrice}

                                            onChange={(e) => setMaxPrice(e.target.value)}

                                            className="
                        w-full
                        lg:w-24
                        px-3
                        py-3
                        rounded-2xl
                        border
                        border-[#DDD2BA]
                        dark:border-gray-700
                        bg-white
                        dark:bg-gray-800
                        text-sm
                        outline-none
                        focus:ring-2
                        focus:ring-[#B89442]
                    "

                                        />

                                    </div>





                                    {/* Rating */}

                                    <select

                                        value={rating}

                                        onChange={(e) => setRating(e.target.value)}

                                        className="
                    px-4
                    py-3
                    rounded-2xl
                    border
                    border-[#DDD2BA]
                    dark:border-gray-700
                    bg-white
                    dark:bg-gray-800
                    text-sm
                    outline-none
                    focus:ring-2
                    focus:ring-[#0F766E]
                "

                                    >

                                        <option value="0">
                                            All Ratings
                                        </option>

                                        <option value="3">
                                            3★ & above
                                        </option>

                                        <option value="4">
                                            4★ & above
                                        </option>

                                        <option value="4.5">
                                            4.5★ & above
                                        </option>


                                    </select>





                                    {/* Destination */}

                                    <select

                                        className="
                    px-4
                    py-3
                    rounded-2xl
                    border
                    border-[#DDD2BA]
                    dark:border-gray-700
                    bg-white
                    dark:bg-gray-800
                    text-sm
                    outline-none
                    focus:ring-2
                    focus:ring-[#0F766E]
                "

                                        onChange={(e) => {

                                            const dest =
                                                destinations.find(
                                                    d => d.id == e.target.value
                                                );

                                            if (dest) {
                                                handleDestinationChange(dest);
                                            }

                                        }}

                                    >

                                        <option value="">
                                            Destinations
                                        </option>


                                        {
                                            destinations.map(dest => (

                                                <option
                                                    key={dest.id}
                                                    value={dest.id}
                                                >
                                                    {dest.name}
                                                </option>

                                            ))
                                        }


                                    </select>






                                    {/* Reset */}

                                    {
                                        isFilterChanged && (

                                            <button

                                                onClick={resetFilters}

                                                className="
                            flex
                            items-center
                            justify-center
                            gap-2
                            px-5
                            py-3
                            rounded-2xl
                            bg-gradient-to-r
                            from-[#B89442]
                            to-[#D4B76A]
                            text-white
                            text-sm
                            font-medium
                            shadow-lg
                            hover:scale-105
                            transition
                        "

                                            >

                                                <FaUndo />

                                                Reset

                                            </button>

                                        )
                                    }


                                </div>


                            </div>


                        </div>
                    )}

                    {/* Hotels */}
                    <div className="w-full">

                        {/* Top Bar */}
                        {location.pathname === "/hotels" && (
                            <div className="
    flex 
    flex-col 
    md:flex-row 
    md:items-center 
    md:justify-between 
    gap-4 
    mb-8
">

                                <div>

                                    <h2 className="
            text-3xl
            font-bold
            text-[#1F2937]
            dark:text-white
        ">

                                        Showing

                                        <span className="
                mx-2
                text-[#B89442]
                relative
            ">
                                            {hotels.length}
                                        </span>

                                        Hotels

                                    </h2>


                                    <p className="
            text-gray-500
            dark:text-gray-400
            mt-2
            flex
            items-center
            gap-2
        ">

                                        <span className="
                w-8
                h-[2px]
                bg-[#0F766E]
                inline-block
            "></span>

                                        Discover luxury stays across Dubai

                                    </p>


                                </div>


                            </div>
                        )}

                        {loading ? (
                            <div className="flex flex-col items-center justify-center py-28 text-center">

                                <div className="relative w-24 h-24 mb-6">

                                    <div className="absolute inset-0 rounded-full border-4 border-blue-100 dark:border-blue-900"></div>

                                    <div className="absolute inset-0 rounded-full border-4 border-t-blue-600 border-r-transparent border-b-transparent border-l-transparent animate-spin"></div>

                                    <div className="absolute inset-0 flex items-center justify-center">
                                        <div className="w-10 h-10 bg-[#D9BB74] rounded-lg animate-pulse"></div>
                                    </div>

                                </div>

                                <h3 className="text-lg font-semibold text-gray-700 dark:text-white">
                                    Searching the best hotels
                                </h3>

                                <p className="text-gray-500 dark:text-gray-400 mt-2">
                                    Finding perfect stays for your destination...
                                </p>

                                <div className="flex gap-1 mt-4">
                                    <span className="w-2 h-2 bg-[#D9BB74] rounded-full animate-bounce"></span>
                                    <span className="w-2 h-2 bg-[#D9BB74] rounded-full animate-bounce [animation-delay:0.1s]"></span>
                                    <span className="w-2 h-2 bg-[#D9BB74] rounded-full animate-bounce [animation-delay:0.2s]"></span>
                                </div>

                            </div>
                        ) : (
                            <>
                                <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                                    {(limit ? hotels.slice(0, limit) : hotels).map((hotel) => (
                                        <div
                                            key={hotel.id}
                                            onClick={() => navigate(`/hotels/${hotel.slug ?? hotel.id}`)}
                                            className="
        group
        rounded-[32px]
        transition
        duration-500
        cursor-pointer
        h-full
    "
                                        >

                                            {/* Skeleton Card */}
                                            {!loadedImages[hotel.id] && (
                                                <div className="
            rounded-[32px]
            overflow-hidden
            bg-white
            shadow-lg
            animate-pulse
        ">

                                                    <div className="
                h-[320px]
                bg-gradient-to-r
                from-gray-200
                via-gray-100
                to-gray-200
            "></div>


                                                    <div className="p-5 space-y-4">

                                                        <div className="h-5 bg-gray-200 rounded w-3/4"></div>

                                                        <div className="h-3 bg-gray-200 rounded w-full"></div>

                                                        <div className="h-3 bg-gray-200 rounded w-5/6"></div>


                                                        <div className="flex gap-2">
                                                            <div className="h-6 w-20 bg-gray-200 rounded-full"></div>
                                                            <div className="h-6 w-20 bg-gray-200 rounded-full"></div>
                                                        </div>


                                                        <div className="border-t pt-4 flex justify-between">
                                                            <div className="h-8 w-28 bg-gray-200 rounded"></div>
                                                            <div className="h-5 w-20 bg-gray-200 rounded"></div>
                                                        </div>

                                                    </div>

                                                </div>
                                            )}



                                            {/* Actual Card */}

                                            <div
                                                className={`
        transition-all
        duration-700
        h-full
        flex
        flex-col
        ${loadedImages[hotel.id]
                                                        ? "opacity-100 translate-y-0"
                                                        : "opacity-0 hidden"
                                                    }
    `}
                                            >


                                                {/* Image Section */}

                                                <div className="relative overflow-hidden rounded-t-[140px]">


                                                    <img
                                                        src={`https://uaedubaihotels.com/uploads/hotels/${hotel.image}`}
                                                        alt={hotel.name}

                                                        onLoad={() =>
                                                            setLoadedImages((prev) => ({
                                                                ...prev,
                                                                [hotel.id]: true,
                                                            }))
                                                        }

                                                        className="
                    w-full
                    h-[320px]
                    object-cover
                    transition-all
                    duration-700
                    group-hover:scale-110
                "
                                                    />


                                                    {/* Overlay */}

                                                    <div className="
                absolute inset-0
                bg-gradient-to-t
                from-black/85
                via-black/20
                to-transparent
            " />



                                                    {/* Bottom Image Content */}

                                                    <div className="absolute bottom-0 left-0 right-0 p-5">


                                                        <div className="flex items-center justify-between mb-3">


                                                            {/* Deal Badge */}

                                                            <div className="relative">


                                                                <span className="
                            absolute inset-0
                            rounded-full
                            bg-red-500
                            animate-ping
                            opacity-30
                        "></span>


                                                                <span
                                                                    className={`
                                relative inline-flex items-center gap-2
                                rounded-full px-4 py-2
                                shadow-xl
                                transition-all
                                duration-300
                                group-hover:scale-105

                                ${Number(hotel.price_per_night) <= 150
                                                                            ?
                                                                            "bg-gradient-to-r from-red-600 to-red-500 text-white"

                                                                            :

                                                                            Number(hotel.price_per_night) <= 250

                                                                                ?

                                                                                "bg-gradient-to-r from-green-600 to-green-500 text-white"

                                                                                :

                                                                                "bg-gradient-to-r from-red-600 via-red-500 to-green-600 text-white"
                                                                        }
                            `}
                                                                >


                                                                    {
                                                                        Number(hotel.price_per_night) <= 150
                                                                            ?

                                                                            <BadgePercent
                                                                                className="w-5 h-5 animate-pulse"
                                                                            />

                                                                            :

                                                                            <Crown
                                                                                className="w-5 h-5 animate-pulse"
                                                                            />
                                                                    }



                                                                    <div className="leading-tight">

                                                                        <p className="
                                    text-[9px]
                                    uppercase
                                    tracking-widest
                                    text-white/80
                                ">
                                                                            Limited Time
                                                                        </p>


                                                                        <p className="text-xs font-bold">

                                                                            {
                                                                                Number(hotel.price_per_night) <= 150
                                                                                    ?
                                                                                    "Best Price"

                                                                                    :

                                                                                    Number(hotel.price_per_night) <= 250

                                                                                        ?

                                                                                        "Save Today"

                                                                                        :

                                                                                        "Exclusive Deal"
                                                                            }

                                                                        </p>


                                                                    </div>


                                                                </span>


                                                            </div>



                                                            {/* Rating */}

                                                            <div className="
                        flex items-center gap-1
                        bg-white/20
                        backdrop-blur-md
                        px-2.5
                        py-1
                        rounded-full
                    ">

                                                                <Star
                                                                    size={12}
                                                                    className="fill-[#FFD54A] text-[#FFD54A]"
                                                                />

                                                                <span className="text-white text-xs font-medium">
                                                                    {hotel.rating || "4.5"}
                                                                </span>


                                                            </div>



                                                        </div>



                                                        {/* Hotel Name */}

                                                        <h3 className="
                    text-white
                    text-lg
                    font-semibold
                    mb-1
                    line-clamp-1
                ">
                                                            {hotel.name}
                                                        </h3>



                                                        {/* Location */}

                                                        <p className="
                    text-white/80
                    text-xs
                    flex
                    items-center
                    gap-1
                ">

                                                            <FaMapMarkerAlt size={12} />

                                                            {hotel.location || hotel.city || "Dubai, UAE"}

                                                        </p>


                                                    </div>


                                                </div>



                                                {/* Content Section */}


                                                <div className="
    p-5
    rounded-b-2xl
    border
    border-[#DDD2BA]
    bg-[#FCFAF5]
    flex
    flex-col
    flex-1
">



                                                    {/* Description */}

                                                    <p className="
    text-gray-500
    text-sm
    leading-6
    line-clamp-3
    min-h-[72px]
    mb-5
">

                                                        {
                                                            hotel.short_description
                                                                ?.replace(/<[^>]*>/g, "")
                                                            ||
                                                            "Experience premium accommodation with world-class facilities and exclusive hotel offers."
                                                        }

                                                    </p>



                                                    {/* Amenities */}

                                                    <div className="
    flex
    flex-wrap
    gap-2
    mb-5
    min-h-[32px]
">


                                                        {
                                                            hotel.amenities?.slice(0, 3).map((item, index) => (

                                                                <span
                                                                    key={index}
                                                                    className="
                                inline-flex
                                items-center
                                gap-1
                                text-[11px]
                                bg-[#EFE7D5]
                                text-[#0F766E]
                                px-2.5
                                py-1
                                rounded-full
                            "
                                                                >

                                                                    {amenityIcons[item] || null}

                                                                    {item}

                                                                </span>

                                                            ))
                                                        }


                                                    </div>




                                                    {/* Footer */}

                                                    <div className="
    border-t
    border-[#DDD2BA]
    pt-5
    mt-auto
    flex
    items-center
    justify-between
">


                                                        <div>

                                                            <p className="
                        text-2xl
                        font-semibold
                        text-[#1F2937]
                    ">

                                                                AED {Number(hotel.price_per_night).toLocaleString()}

                                                            </p>


                                                            <p className="
                        text-[11px]
                        uppercase
                        tracking-wider
                        text-gray-500
                    ">
                                                                Per Night
                                                            </p>


                                                        </div>




                                                        <button

                                                            onClick={(e) => {

                                                                e.stopPropagation();

                                                                navigate(`/hotels/${hotel.slug}`);

                                                            }}

                                                            className="
                        text-[#0F766E]
                        text-sm
                        font-medium
                        border-b
                        border-[#0F766E]
                        pb-1
                        transition-all
                        duration-300
                        hover:text-[#B89442]
                        hover:border-[#B89442]
                    "
                                                        >

                                                            View Deal →

                                                        </button>



                                                    </div>


                                                </div>


                                            </div>


                                        </div>
                                    ))}
                                </div>

                                {/* Mobile View All Button */}
                                {showHeading && (
                                    <div className="mt-8 sm:hidden">
                                        <button
                                            onClick={() => navigate("/hotels")}
                                            className="w-full bg-[#FF6B35] text-white px-5 py-3 rounded-xl hover:bg-orange-600 transition text-sm font-medium"
                                        >
                                            View All
                                        </button>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>

    );
}